class FrontendLogger {
  constructor() {
    // this.isDevelopment = process.env.NODE_ENV === 'development';
      this.isDevelopment = false;
}

  getTimestamp() {
    return new Date().toISOString();
  }

  formatMessage(level, message, data = null) {
    const timestamp = this.getTimestamp();
    const logEntry = {
      timestamp,
      level,
      message,
      data,
      userAgent: navigator.userAgent,
      url: window.location.href
    };
    return logEntry;
  }

  log(level, message, data = null) {
    const logEntry = this.formatMessage(level, message, data);
    
    // Console output with styling
/*
    const style = this.getConsoleStyle(level);
    console.group(`%c[${level.toUpperCase()}] ${message}`, style);
    console.log('Timestamp:', logEntry.timestamp);
    console.log('URL:', logEntry.url);
    if (data) {
      console.log('Data:', data);
    }
    console.groupEnd();
    
    // Store in localStorage for debugging (optional)
    if (this.isDevelopment) {
      this.storeLog(logEntry);
    }
*/
    }

  getConsoleStyle(level) {
    const styles = {
      info: 'color: #0066cc; font-weight: bold;',
      warn: 'color: #ff6600; font-weight: bold;',
      error: 'color: #cc0000; font-weight: bold;',
      debug: 'color: #666666; font-weight: bold;',
      success: 'color: #00cc00; font-weight: bold;'
    };
    return styles[level] || styles.info;
  }

  storeLog(logEntry) {
    try {
      const logs = JSON.parse(localStorage.getItem('frontend_logs') || '[]');
      logs.push(logEntry);
      
      // Keep only last 100 logs
      if (logs.length > 100) {
        logs.splice(0, logs.length - 100);
      }
      
      localStorage.setItem('frontend_logs', JSON.stringify(logs));
    } catch (error) {
      console.warn('Failed to store log:', error);
    }
  }

  info(message, data = null) {
    this.log('info', message, data);
  }

  warn(message, data = null) {
    this.log('warn', message, data);
  }

  error(message, data = null) {
    this.log('error', message, data);
  }

  debug(message, data = null) {
    this.log('debug', message, data);
  }

  success(message, data = null) {
    this.log('success', message, data);
  }

  // API specific logging
  logAPI(method, url, data = null, response = null) {
    this.info(`API: ${method} ${url}`, {
      method,
      url,
      requestData: data,
      responseData: response,
      timestamp: this.getTimestamp()
    });
  }

  logAuth(action, details = null) {
    this.info(`AUTH: ${action}`, {
      action,
      details,
      timestamp: this.getTimestamp()
    });
  }

  logUserAction(action, details = null) {
    this.info(`USER_ACTION: ${action}`, {
      action,
      details,
      timestamp: this.getTimestamp()
    });
  }

  logError(error, context = null) {
    this.error('ERROR', {
      message: error.message,
      stack: error.stack,
      context,
      timestamp: this.getTimestamp()
    });
  }

  // Get stored logs for debugging
  getStoredLogs() {
    try {
      return JSON.parse(localStorage.getItem('frontend_logs') || '[]');
    } catch (error) {
      console.warn('Failed to get stored logs:', error);
      return [];
    }
  }

  // Clear stored logs
  clearStoredLogs() {
    localStorage.removeItem('frontend_logs');
  }
}

export default new FrontendLogger(); 